import React, { useEffect } from "react"
import { SearchOutlined, UploadOutlined } from "@ant-design/icons"
import { Input, Button, message, Tooltip, Table, Tag, DatePicker } from "antd"
import { copyToClipboard } from "../../utils/utils"
import history from "utils/history"
import Loader from "components/Loader"

import { uniq, uniqBy, get, debounce } from "lodash"

import "./index.less"
import SegmentsModal from "../CollaboratorsTable/SegmentsModal"
import { LOCAL_USER_ID } from "../../utils/storage"
import { PAGINATION_DEFAULT, TYPE_SURVEY } from "../../utils/constants"
import moment from "moment"
import { validate } from "../../utils/functions"
import { buttonAction_s } from "../Snowplow/config2"

const { RangePicker } = DatePicker

const MeasureSelectRecipientsSegments = (props) => {
  const [recipientSearch, setRecipientSearch] = React.useState("")
  const [showSegmentsModal, setShowSegmentsModal] = React.useState(false)
  const [
    collaboratorNameForModal,
    setCollaboratorNameForModal,
  ] = React.useState("")
  const [segmentsForModal, setSegmentsForModal] = React.useState([])
  const [selectedRowsKeys, setSelectedRowsKeys] = React.useState([])
  const [dataSource, setDataSource] = React.useState([])
  const [allSegments, setAllSegments] = React.useState([])
  const [admissionDate, setAdmissionDate] = React.useState({})
  const [segmentFilter, setSegmentFilter] = React.useState([])
  const [loading, setLoading] = React.useState(false)

  const { measure, idSurveyType } = props

  useEffect(() => {
    getEmployeesBySegments()
  }, [])

  useEffect(() => {
    if (get(props.recipientsStepData, "employees", []).length > 0) {
      props.setStateFrom(
        "selectedEmployees",
        props.recipientsStepData.employees
      )
      setSelectedRowsKeys(props.recipientsStepData.employees)
    }
  }, [props.recipientsStepData])

  useEffect(() => {
    if (props.employeesBySegments.length) {
      setDataSource(props.employeesBySegments)
      let testSegments = []
      props.employeesBySegments.forEach((employee) => {
        testSegments = testSegments.concat(employee.segments)
      })
      setAllSegments(uniqBy(testSegments, "id_segment"))
    }
  }, [props.employeesBySegments])

  useEffect(() => {
    applyFilterEmployeesBySegments()
  }, [admissionDate, segmentFilter])

  const getEmployeesBySegments = () => {
    let segmentsSelected = props.measure.segments.map(
      (segment) => segment.id_segment
    )
    if (validate.exist(segmentFilter) && segmentFilter.length > 0) {
      segmentsSelected = [...segmentFilter]
    }
    const params = { segments: segmentsSelected, ...admissionDate }
    props.getEmployeesBySegmentsWatcher(params)
  }

  const applyFilterEmployeesBySegments = (recipientSearchParams = "") => {
    const hasDate = admissionDate && validate.exist(admissionDate.dateStart)
    const hasSegment = validate.exist(segmentFilter) && segmentFilter.length > 0
    let hasSearch = !validate.empty(recipientSearch)
    let searchText = recipientSearch
    if (!validate.empty(recipientSearch)) {
      hasSearch = true
      searchText = recipientSearchParams
    }

    setLoading(true)
    let source
    if (hasDate || hasSegment || hasSearch) {
      // COMMENT: clean select rows by filter
      // setSelectedRowsKeys([])
      source = props.employeesBySegments
        .filter((item) => {
          let response = true
          if (hasSearch && !validate.empty(searchText)) {
            let valueFilter = searchText.toLowerCase()
            response =
              item.full_name.toLowerCase().includes(valueFilter) ||
              item.division_name.toLowerCase().includes(valueFilter) ||
              item.employee_parent_name.toLowerCase().includes(valueFilter) ||
              item.plevel_name.toLowerCase().includes(valueFilter) ||
              item.location.toLowerCase().includes(valueFilter) ||
              searchSegments(valueFilter, item.segments)
          }
          return response
        })
        .filter((item) => {
          let response = true
          if (hasSegment) {
            const segments = item.segments.map((item) => item.id_segment)
            response = indexOfForArrays(segments, segmentFilter)
          }
          return response
        })
        .filter((item) => {
          const { dateStart, dateEnd } = admissionDate
          let response = true
          if (hasDate) {
            response =
              formatDate(item.date_admission, "YYYY-MM-DD") >= dateStart &&
              formatDate(item.date_admission, "YYYY-MM-DD") <= dateEnd
          }
          return response
        })
    } else {
      source = props.employeesBySegments
    }

    setTimeout(() => {
      setLoading(false)
      setDataSource(source)
    }, 500)
  }

  const formatDate = (date, format) => {
    return moment(date).format(format)
  }

  const indexOfForArrays = (values, val) => {
    return values.filter((e) => val.includes(e)).length > 0
  }

  const searchSegments = (search, segments) => {
    return segments.some((segment) => {
      return segment.name_segment.includes(search)
    })
  }
  // snowplow
  let data_button_import = {
    category: window.location.hash
      ? window.location.hash
      : window.location.pathname,
    action: "Importar destinatarios",
    label: "Click a Importar destinatarios",
    property: "Button",
    value: LOCAL_USER_ID(),
  }
  const handleImport = () => {
    props.saveRecipients()
    localStorage.setItem("currentMeasure", props.measure.id_measure)
    buttonAction_s(data_button_import)
    history.push(
      `/models/measure/${props.measure.id_measure}/import-recipients/`
    )
  }
  // snowplow
  let data_button = {
    category: window.location.hash
      ? window.location.hash
      : window.location.pathname,
    action: "Copiar link",
    label: "Click a Copiar link",
    property: "Button",
    value: LOCAL_USER_ID(),
  }

  const toggleSegmentsModal = (segments, collabName) => {
    setSegmentsForModal(segments)
    setCollaboratorNameForModal(collabName)
    setShowSegmentsModal(true)
  }

  const applyFilterAdmissionDate = (values) => {
    if (validate.exist(values)) {
      const date = [...values]
      setAdmissionDate({
        dateStart: moment(date[0]).format("Y-MM-DD"),
        dateEnd: moment(date[1]).format("Y-MM-DD"),
      })
    } else {
      setAdmissionDate({})
    }
  }

  const onChangeTable = (pagination, filters) => {
    if (validate.exist(filters.segment)) {
      setSegmentFilter(filters.segment)
      // COMMENT: clean select rows by change table
      // setSelectedRowsKeys([])
      // props.setStateFrom("selectedEmployees", [])
    } else {
      setSegmentFilter([])
    }
  }

  const columns = () => {
    const { id_survey_type } = measure
    const isOnboarding = id_survey_type === TYPE_SURVEY.onboarding.idSurveyType

    const columns = [
      {
        title: "Colaborador",
        dataIndex: "name",
        key: "name",
        visible: true,
        render: (text, record) => <span>{record.full_name}</span>,
      },
      {
        title: "Segmento",
        dataIndex: "segment",
        key: "segment",
        visible: true,
        filterSearch: true,
        filters: allSegments.map((segment) => {
          return { text: segment.name_segment, value: segment.id_segment }
        }),
        onFilter: (value, record) =>
          record.segments.some((segment) => segment.id_segment === value),
        render: (text, row) => {
          let tags = []
          if (row.segments.length > 0) {
            tags.push(
              <Tag
                style={{
                  maxWidth: "100px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}>
                {row.segments[0].name_segment}
              </Tag>
            )
            if (row.segments.length > 1) {
              tags.push(
                <Tooltip
                  title={() => {
                    let segmentsName = []
                    for (let i = 0; i < row.segments.length; i++) {
                      if (i === 10) {
                        segmentsName.push(
                          <p
                            style={{ margin: 0, cursor: "pointer" }}
                            onClick={() => {
                              toggleSegmentsModal(row.segments, row.full_name)
                            }}>
                            Ver más
                          </p>
                        )
                        break
                      }
                      segmentsName.push(
                        <p
                          style={{
                            margin: 0,
                            maxWidth: "150px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}>
                          {i + 1}. {row.segments[i].name_segment}
                        </p>
                      )
                    }
                    return <>{segmentsName}</>
                  }}>
                  <Tag
                    style={{
                      pointer: "cursor",
                      maxWidth: "50px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}>
                    {row.segments.length - 1}+
                  </Tag>
                </Tooltip>
              )
            }
          } else {
            tags.push(<span>-</span>)
          }

          return tags
        },
      },
      {
        title: "División",
        dataIndex: "division",
        key: "division",
        visible: true,
        render: (text, record) => <span>{record.division_name}</span>,
      },
      {
        title: "Fecha de ingreso",
        dataIndex: "date_admission",
        key: "date_admission",
        visible: isOnboarding,
        render: (text, record) => <span>{record.date_admission_visible}</span>,
      },
      {
        title: "Líder",
        dataIndex: "leader",
        key: "leader",
        visible: true,
        render: (text, record) => (
          <span>
            {record.employee_parent_name === ""
              ? "-"
              : record.employee_parent_name}
          </span>
        ),
      },
      {
        title: "Categoría jerárquica",
        dataIndex: "category",
        key: "category",
        visible: true,
        render: (text, record) => (
          <span>{record.plevel_name === "" ? "-" : record.plevel_name}</span>
        ),
      },
      {
        title: "Ubicación geográfica",
        dataIndex: "location",
        key: "location",
        visible: true,
        render: (text, record) => (
          <span>{record.location === "" ? "-" : record.location}</span>
        ),
      },
      {
        title: "Género",
        dataIndex: "gender",
        key: "gender",
        visible: true,
        render: (text, record) => <span>{record.gender_name}</span>,
      },
    ]

    return [...columns.filter((item) => item.visible)]
  }

  const rowSelection = {
    selectedRowKeys: selectedRowsKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowsKeys(selectedRowKeys)
      const selectedIds = selectedRows.map((row) => row.id_employee)
      props.setStateFrom("selectedEmployees", selectedIds)
    },
    selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
  }

  const searchEmployeesBySegments = debounce(
    applyFilterEmployeesBySegments,
    500
  )

  return (
    <div className="measure-select-recipient">
      <div className="measure-select-recipient-header">
        <div>
          <div className="measure-select-recipient-header-title">
            Seleccionar destinatarios
          </div>
          <div className="measure-select-recipient-header-description">
            Selecciona los colaboradores a las que deseas enviar la encuesta:
          </div>
          <div className="measure-select-recipient-header-input">
            <Input
              allowClear
              placeholder="Buscar..."
              suffix={<SearchOutlined />}
              onChange={(e) => {
                setRecipientSearch(e.target.value)
                searchEmployeesBySegments(e.target.value)
              }}
            />
            <Tooltip
              placement="bottom"
              title="Importar destinatarios"
              className="btn-tooltip">
              <Button
                className="whiteButton"
                size="default"
                icon={<UploadOutlined />}
                onClick={handleImport}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              />
            </Tooltip>
          </div>
        </div>
        <div className="measure-select-recipient-header-copylink">
          <div>
            Recuerda que los destinatarios que no cuenten con correo electrónico{" "}
            <br /> deberán entrar al siguiente <span>link</span> con su DNI para
            responder la encuesta:
          </div>
          <div className="measure-select-recipient-header-copylink-actions">
            <Input
              placeholder={`${process.env.QUESTIONNAIRE_URL}`}
              value={`${process.env.QUESTIONNAIRE_URL}`}
              disabled
            />
            <Button
              onClick={() => {
                copyToClipboard(process.env.QUESTIONNAIRE_URL)
                message.info("El link de la encuesta ha sido copiado.")
                buttonAction_s(data_button)
              }}>
              Copiar link
            </Button>
          </div>
        </div>
      </div>
      <div className="measure-select-recipient-content">
        <div className="filter-inline-table">
          {idSurveyType === TYPE_SURVEY.onboarding.idSurveyType ? (
            <div className="date-picker-start">
              <div>Fecha de ingreso:</div>
              <div>
                <RangePicker
                  placeholder={["Fecha inicio", "Fecha fin"]}
                  onChange={(e) => {
                    applyFilterAdmissionDate(e)
                    setSelectedRowsKeys([])
                  }}
                />
              </div>
            </div>
          ) : (
            <div />
          )}
          <div className="total-recipients">
            Total de destinatarios:{" "}
            {props.selectedEmployees ? uniq(props.selectedEmployees).length : 0}
          </div>
        </div>
        {!props.isLoadingEmployeesBySegments && (
          <Table
            rowKey={(record) => record.id_employee}
            rowSelection={rowSelection}
            columns={columns()}
            dataSource={dataSource}
            loading={loading}
            pagination={{
              pageSizeOptions: [15, 20, 50, 100],
              showSizeChanger: true,
              size: "default",
              defaultPageSize: 15,
            }}
            bordered
            size="small"
            showSorterTooltip={false}
            onChange={onChangeTable}
          />
        )}
        {props.isLoadingEmployeesBySegments && <Loader />}
      </div>
      <SegmentsModal
        segments={segmentsForModal}
        collaboratorName={collaboratorNameForModal}
        show={showSegmentsModal}
        onOk={() => {
          setShowSegmentsModal(false)
        }}
      />
    </div>
  )
}

export default MeasureSelectRecipientsSegments
